import React, { useMemo } from 'react';

import connect from 'components/lib/connect';

export const DEFAULT_IS_TEAM_FLAG_ENABLED_CONTEXT = null;

const IsTeamFlagEnabledContext = React.createContext(DEFAULT_IS_TEAM_FLAG_ENABLED_CONTEXT);
export default IsTeamFlagEnabledContext;

export function IsTeamFlagEnabledProviderBase({ teams, teamsImm, currentAgent, children }) {
  const value = useMemo(() => {
    if (!teams || !currentAgent) return null;

    const agentId = currentAgent.id;
    const agentTeams = teams.filter(team => team.agentIds && team.agentIds.includes(agentId));
    const enabledFeatures = new Set();
    agentTeams.forEach(team => {
      (team.enabledFeatures || []).forEach(f => {
        enabledFeatures.add(f);
      });
    });
    return enabledFeatures;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamsImm, currentAgent]);

  return <IsTeamFlagEnabledContext.Provider value={value}>{children}</IsTeamFlagEnabledContext.Provider>;
}

export const IsTeamFlagEnabledProvider = connect(mapStateToProps)(IsTeamFlagEnabledProviderBase);

function mapStateToProps({ getProvider }) {
  const teamsProvider = getProvider('teams');
  return {
    teams: teamsProvider.findAll(),
    teamsImm: teamsProvider.immutableStore.binding.get(),
    currentAgent: getProvider('currentAgent').get(),
  };
}
